/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
import React from 'react'
import PropTypes from 'prop-types'
import { Container } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import cn from 'classnames'
import { useStaticQuery, graphql } from 'gatsby'

import Icon from '~components/Icon'

import * as s from './Roadmap.module.scss'

const ROADMAP_QUERY = graphql`
  query {
    projectJson {
      projectData {
        roadmapSteps {
          heading
          id
          stepStatus
          objectives {
            isCompleted
            text
          }
        }
        roadmapHeading
      }
    }
  }
`

const Roadmap = ({ id, isPlay }) => {
  const { projectJson } = useStaticQuery(ROADMAP_QUERY)
  const { roadmapSteps, roadmapHeading } = projectJson.projectData

  return (
    <section id={id} className={cn(s.roadmap, { [s.play]: isPlay })}>
      <Container className={cn(s.roadmap_heading)}>
        <h2>{roadmapHeading}</h2>
        <div className="swiper-nav">
          <button
            type="button"
            aria-label="preview"
            className="swiper-button swiper-button-prev swiper-button-prev--roadmap btn-play"
          >
            <Icon name="arrow-right" size={[25, 12]} />
          </button>
          <button
            type="button"
            aria-label="next"
            className="swiper-button swiper-button-next swiper-button-next--roadmap btn-play"
          >
            <Icon name="arrow-right" size={[25, 12]} />
          </button>
        </div>
      </Container>
      <div className={s.roadmap_inner}>
        <Container>
          <Swiper
            slidesPerView={1}
            spaceBetween={16}
            initialSlide={4}
            navigation={{
              prevEl: '.swiper-button-prev--roadmap',
              nextEl: '.swiper-button-next--roadmap',
            }}
            breakpoints={{
              640: { spaceBetween: 40, slidesPerView: 2 },
              1024: { spaceBetween: 40, slidesPerView: 3, initialSlide: 3 },
            }}
            modules={[Navigation]}
          >
            {roadmapSteps.map(({ id, stepStatus, heading, objectives }) => (
              <SwiperSlide
                key={id}
                className={cn(s.roadmap_item, s[`${stepStatus.toLowerCase()}`])}
              >
                <div className={s.roadmap_wrapper}>
                  <h3 className={s.roadmap_statusHeading}>{heading}</h3>
                  <small
                    className={cn(
                      s.roadmap_status,
                      s[`${stepStatus.toLowerCase()}`]
                    )}
                  >
                    {stepStatus}
                  </small>
                </div>
                <ul>
                  {objectives.map((objective, i) => (
                    <li key={`o${i}`} className={s.roadmap_bullet}>
                      {objective.isCompleted && (
                        <span className={s.roadmap_completed}>Completed</span>
                      )}
                      {objective.text}
                    </li>
                  ))}
                </ul>
              </SwiperSlide>
            ))}
          </Swiper>
        </Container>
      </div>
    </section>
  )
}

Roadmap.defaultProps = {
  id: undefined,
  isPlay: false,
}

Roadmap.propTypes = {
  id: PropTypes.string,
  isPlay: PropTypes.bool,
}

export default Roadmap
